import { render, staticRenderFns } from "./cooking-tips-best-practices-detail-page.vue?vue&type=template&id=1c460390&scoped=true"
import script from "./cooking-tips-best-practices-detail-page.vue?vue&type=script&lang=js"
export * from "./cooking-tips-best-practices-detail-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c460390",
  null
  
)

export default component.exports